import { ChatMessageDtoType } from '@/api/generated';

export type Chunk = {
  type: string;
  content: string;
};

export type ChatHistoryItem = {
  type: ChatMessageDtoType;
  response: string;
};

export const DEFAULT_THREAD_TITLE = 'New Thread';

export const DEFAULT_THREAD_ID = '';
export const DEFAULT_CHAT_PROMPT = '';
